<template>
	<scoped-overflow-layout :loading="!isReady">
		<template #toolbar>
			<v-toolbar flat dense color="white">
				<bar-nav-back @navBack="navBack" />
				<v-tooltip bottom>
					<template #activator="data">
						<v-btn small icon v-on="data.on" @click="createFeedback(id)">
							<v-icon :color="toolbarIconColor" :size="toolbarIconSize">mdi-book-plus</v-icon>
						</v-btn>
					</template>
					<span>{{ $t('ACTION_TOOLBAR_ADD_FEEDBACK_HINT') }}</span>
				</v-tooltip>
				<menu-edit
					:removable="isAuthor"
					:message="$t('ACTION_DELETE_CONFIRM_TITLE')"
					:details="$t('ACTION_DELETE_CONFIRM_DETAILS')"
					@edit="editAction"
					@remove="deleteAction" />
				
				<v-spacer />
				
				<bar-pagination :page="page" :count="1" :total="actions.length" @previous="prevItem" @next="nextItem" />
			</v-toolbar>
		</template>

		<v-container fluid>
			<v-layout>
				<v-flex xs12 sm12 lg8 offset-lg2 xl6 offset-xl3>
					<action-card :item="item" :comments="comments" :feedbacks="feedbacks" />
				</v-flex>
			</v-layout>
			<v-flex xs12 sm12 lg8 offset-lg2 xl6 offset-xl3>
				<footer-info :item="item" />
			</v-flex>
		</v-container>
	</scoped-overflow-layout>
</template>


<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import ScopedOverflowLayout from "@/layouts/ScopedOverflowLayout.vue";
import MenuEdit from '@/dialogs/MenuEdit';
import BarNavBack from "@/components/BarNavBack.vue";
import BarPagination from "@/components/BarPagination.vue";
import FooterInfo from "@/components/FooterInfo.vue";
import ActionCard from "@/components/ActionCard.vue";

export default {
	name: "action",
	components: { ScopedOverflowLayout, BarNavBack, BarPagination, MenuEdit, ActionCard, FooterInfo },
	props: {
		id: Number,
	},
	computed: {
		...mapState(['toolbarIconColor', 'toolbarIconSize']),
		...mapGetters('auth', ['userID']),
		...mapGetters('actions', {
			actions: 'filtered',
			filter: 'currentRouteFilter',
		}),
		isReady() {
			return !!this.item.id;
		},
		item() {
			return this.$store.getters['actions/current'] || {};
		},
		page() {
			return this.actions.indexOf(this.item);
		},
		isAuthor() {
			return this.userID === this.item.author;
		},
		comments() {
			return this.$store.getters['comments/byAction'](this.id) || [];
		},
		feedbacks() {
			return this.$store.getters['feedbacks/byAction'](this.id) || [];
		},
	},
	methods: {
		...mapActions('feedbacks', ['createFeedback']),
		async fetchData() {
			await Promise.all([
				this.$store.dispatch('likes/fetchByActionID',     this.id),
				this.$store.dispatch('comments/fetchByActionID',  this.id),
				this.$store.dispatch('feedbacks/fetchByActionID', this.id),
			]);
			this.$store.commit('actions/setCurrent', this.id);
		},
		navBack() {
			this.$router.go(-1);
		},
		editAction() {
			this.$store.dispatch('actions/editAction', { item: this.item });
		},
		async deleteAction() {
			this.navBack();
			await this.$store.dispatch('actions/deleteAction', { item: this.item });
		},
		prevItem({ index }) {
			const previous = this.actions[index];
			this.$router.replace({ name: 'action-details', params: { filter: this.filter, id: previous.id } });
		},
		nextItem({ index }) {
			const next = this.actions[index];
			this.$router.replace({ name: 'action-details', params: { filter: this.filter, id: next.id } });
		},
	},
	created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData',
	},
};
</script>
